<template>
  <div>
    <svg
      class="main-layout__item-icon"
      @click="openCall(user)"
      id="svg-user-phone"
      viewBox="0 0 30 30"
    >
      <title>B4A39D23-7647-4B27-A16C-1346953D4E69</title>
      <path
        d="M15.007 29.985A14.958 14.958 0 0 1 4.4 25.6c-5.85-5.85-5.85-15.365 0-21.214 5.847-5.848 15.366-5.848 21.213 0 5.85 5.849 5.85 15.364 0 21.213a14.958 14.958 0 0 1-10.606 4.386zm0-27.587a12.564 12.564 0 0 0-8.91 3.684c-4.913 4.913-4.913 12.908 0 17.82 4.912 4.913 12.907 4.913 17.82 0 4.912-4.912 4.912-12.907 0-17.82a12.564 12.564 0 0 0-8.91-3.683zm4.677 20.54c-.76 0-1.507-.198-2.167-.575a25.87 25.87 0 0 1-9.385-9.152l-.425-.709a4.322 4.322 0 0 1 .653-5.288l.843-.844a2.376 2.376 0 0 1 3.357 0l1.861 1.86c.75.753.91 1.922.389 2.845l-.543.964 3.693 3.693.963-.544c.93-.52 2.09-.36 2.844.39l1.862 1.861a2.376 2.376 0 0 1 0 3.357l-.881.88a4.326 4.326 0 0 1-3.064 1.262zM10.882 8.085l-.825.826a1.926 1.926 0 0 0-.29 2.358l.424.708a23.39 23.39 0 0 0 8.432 8.255c.866.492 1.805.37 2.427-.252l.88-.881-1.86-1.824-1.209.703a1.987 1.987 0 0 1-2.375-.325l-4.141-4.14a1.993 1.993 0 0 1-.325-2.375l.698-1.24-1.836-1.813z"
        fill="var(--bg-color-green)"
      />
    </svg>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
    props: {
        user: {
            required: true,
        },
    },
    name: 'sip-call-btn',
    methods: {
        ...mapMutations({
            setState: 'sip/setState',
        }),
        openCall(user) {
            this.setState({
                key: 'callee',
                value: user.phone,
            })

            this.setState({
                key: 'callerName',
                value: `${user.first_name} ${user.last_name}`,
            })

            this.setState({
                key: 'isCallToClient',
                value: true,
            })

            this.setState({
                key: 'show',
                value: true,
            })
        },
    },
}
</script>
